import { proxy } from "valtio";
import { ApprovedUrl } from "@models/approvedUrl.model";

interface OrganizationApprovedUrlsState {
  organizationId: number | null;
  urls: ApprovedUrl[];
  isLoading: boolean;
  isSaving: boolean;
  error: string | null;
}

export const organizationApprovedUrlsStore = proxy<OrganizationApprovedUrlsState>({
  organizationId: null,
  urls: [],
  isLoading: false,
  isSaving: false,
  error: null,
});

export function resetOrganizationApprovedUrlsStore() {
  organizationApprovedUrlsStore.organizationId = null;
  organizationApprovedUrlsStore.urls = [];
  organizationApprovedUrlsStore.isLoading = false;
  organizationApprovedUrlsStore.isSaving = false;
  organizationApprovedUrlsStore.error = null;
}
